/**
* Treatment Planner CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the Treatment Planner CTA component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
// import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'treatment-planner-cta',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.treatment-planner-cta' ).each( function( key, val ) {
        // const backgroundImage = $( val ).find( '.treatment-planner-cta__background-image' )[0];
        // const foregroundImage = $( val ).find( '.treatment-planner-cta__foreground-image' )[0];

        const floatingItem1 = $( val ).find( '.treatment-planner-cta__floating-item' )[0];
        const floatingItem2 = $( val ).find( '.treatment-planner-cta__floating-item' )[1];
        const floatingItem3 = $( val ).find( '.treatment-planner-cta__floating-item' )[2];
        const floatingItem4 = $( val ).find( '.treatment-planner-cta__floating-item' )[3];

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: $( val ).find( '.image-wrapper' ),
            start: 'top 100%',
            end: 'bottom 15%',
            scrub: 1,
          },
        } );

        // if ( backgroundImage ) {
        //   tl.to( backgroundImage, {y: '10%', ease: 'linear'}, 0 );
        // }

        // if ( foregroundImage ) {
        //   tl.to( foregroundImage, {y: '0%', ease: 'linear'}, 0 );
        // }

        tl.to( floatingItem1, {y: '0%', ease: 'linear'}, 0 );
        tl.to( floatingItem2, {y: '0%', ease: 'linear'}, 0 );
        tl.to( floatingItem3, {y: '0%', ease: 'linear'}, 0 );
        tl.to( floatingItem4, {y: '0%', ease: 'linear'}, 0 );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'treatment-planner-cta', COMPONENT );
} )( app );
